'use strict';

var Entity_schema = require('../schema/Entity.schema.json.cjs.js');
var ajv = require('./ajv.cjs.js');

function entitySchemaValidator(schema) {
  const validate = ajv.compileAjvSchema(schema ? schema : Entity_schema.default);
  return (data) => {
    const result = validate(data);
    if (result === true) {
      return data;
    }
    throw ajv.throwAjvError(validate.errors);
  };
}

exports.entitySchemaValidator = entitySchemaValidator;
//# sourceMappingURL=entitySchemaValidator.cjs.js.map
